export default __webpack_public_path__ + "static/media/renDOGE-ETH.d2502ef8.png";